export const ARCHIVED = 'ARCHIVED' as const;
export const RELEASED = 'RELEASED' as const;
export const UNARCHIVED = 'UNARCHIVED' as const;
export const UNRELEASED = 'UNRELEASED' as const;

export const FIRST_COLUMN_MIN_WIDTH = 184;

// Link rendered when "latest deployment" section has no recent deployments
export const SUPPORT_DOCS_LINK_URL =
	'https://support.atlassian.com/jira-software-cloud/docs/reference-issues-in-your-development-work/';

const statuses = [ARCHIVED, RELEASED, UNRELEASED, UNARCHIVED];

export default statuses;
